module.exports = __webpack_public_path__ + "img/2025-06-11b_1.ff592639.jpg";